import { t } from 'Src/i18n';
export const IS_DISABLED = 'isDisabled';
export const IS_ENABLED = 'isEnabled';
export const IS_SELECTED = 'isSelected';

const getServiceAgesLabel = (
  ageInMonths: Readonly<{
    min: number;
    max: number | null | undefined;
  }>,
) => {
  const { min, max } = ageInMonths;

  if (min > 23) {
    return t('booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : '',
    });
  }

  if (min < 23 && max && max > 23) {
    return t('booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12),
    });
  }

  return t('booking.services.childcare.kidsAgeInMonths', {
    min: min,
    max: max,
  });
};

function getServiceAgesLabelTranslateOptions(
  ageInMonths: Readonly<{
    min: number;
    max: number | null | undefined;
  }>,
) {
  const { min, max } = ageInMonths;

  if (min > 23) {
    return [
      'booking.services.childcare.kidsAgeInYears',
      {
        min: Math.floor(min / 12),
        max: max ? Math.floor(max / 12) : '',
      },
    ];
  }

  if (min < 23 && max && max > 23) {
    return [
      'booking.services.childcare.kidsAgeInMonthsAndYears',
      {
        min: min,
        max: Math.floor(max / 12),
      },
    ];
  }

  return [
    'booking.services.childcare.kidsAgeInMonths',
    {
      min: min,
      max: max,
    },
  ];
}

const getRentalAgesLabel = (
  ageInMonths: Readonly<{
    min: number;
    max: number | null | undefined;
  }>,
) => {
  if (!ageInMonths || !ageInMonths.min) {
    return t('booking.activities.forAllAges');
  }

  if (ageInMonths.max) {
    return getServiceAgesLabel(ageInMonths);
  }

  if (ageInMonths.min < 23) {
    return t('booking.activities.ageFromMonths', {
      amount: ageInMonths.min,
    });
  }

  return t('booking.activities.ageFrom', {
    age: Math.floor(ageInMonths.min / 12),
  });
};

const createPropsForPictures = (images) => {
  if (!Array.isArray(images)) {
    return [];
  }

  return images.map((link) => {
    return {
      src: link,
    };
  });
};

const createPropsForProduct = (resort: Partial<Product>): ProductProps => ({
  id: resort.id,
  header: {
    className: 'border-r-1',
    heading: {
      subtitle: resort?.destination?.country,
      title: resort.name || '',
    },
    link: {
      url: resort.href,
    },
    productId: resort.id,
    productType: resort.type,
  },
  thumbnail: {
    link: {
      url: resort.href,
    },
    pictures: createPropsForPictures(resort.images),
    productId: resort.id,
    productType: resort.type,
  },
  url: resort.href,
  type: resort.type || '',
});

export {
  createPropsForProduct,
  getRentalAgesLabel,
  getServiceAgesLabel,
  getServiceAgesLabelTranslateOptions,
};
